import React, { useState, useRef, useEffect } from 'react'
import { colors } from './fieldTheme'
import { defaultTourName } from './fieldTours'
import { nowSeconds } from './fieldDates'
import { CheckIcon } from './FieldIcons'
import { BackButton, Pastille, BottomBar, PrimaryButton, ErrorNote } from './FieldUI'

// Nouveau tour de terrain (canvas W14, décisions 4 et 50) : le tour est nommé une fois, nom proposé
// et modifiable ; il est partagé avec l'équipe et reste ouvert jusqu'à ce qu'on le termine.
// Une fois démarré, on arrive sur son plan (M6a).

export default function FieldTourNew({ onStart, onBack })
{
	const [name, setName] = useState(() => defaultTourName(nowSeconds()))
	const [saving, setSaving] = useState(false)
	const [error, setError] = useState(false)
	const inputRef = useRef(null)
	const empty = name.trim() === ''

	useEffect(() => {
		if (inputRef.current)
			inputRef.current.focus()
	}, [])

	const start = () => {
		if (empty || saving)
			return ;
		setSaving(true)
		setError(false)
		Promise.resolve(onStart(name.trim()))
			.catch(() => {
				setSaving(false)
				setError(true)
			})
	}

	return (
		<div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
			<BackButton label="Accueil" onClick={onBack} />
			<div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '24px 20px 0' }}>
				<Pastille type="tour" size={68} illustrationSize={48} />
				<span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2, gap: 4 }}>
					<h1 style={{ fontSize: 26, fontWeight: 800, color: colors.text }}>Nouveau tour de terrain</h1>
					<span style={{ fontSize: 15, fontWeight: 600, color: colors.textSecondary }}>Un inventaire par emplacement</span>
				</span>
			</div>
			<label htmlFor="field-tour-name" style={{ display: 'block', fontSize: 17, fontWeight: 700, color: colors.text, padding: '32px 20px 12px' }}>Nom du tour</label>
			<div style={{ padding: '0 20px' }}>
				<input
					id="field-tour-name"
					ref={inputRef}
					type="text"
					className="browser-default"
					value={name}
					onChange={(e) => setName(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === 'Enter')
							start()
					}}
					style={{ width: '100%', minHeight: 64, margin: 0, padding: '0 20px', borderRadius: 999, border: '3px solid ' + colors.primary, background: colors.surface, fontSize: 20, fontWeight: 700, fontFamily: 'inherit', color: colors.text, boxSizing: 'border-box' }}
				/>
			</div>
			<p style={{ padding: '8px 20px 0', fontSize: 15, fontWeight: 500, color: colors.textSecondary }}>Nom proposé, modifiable.</p>
			<p style={{ padding: '24px 20px 0', fontSize: 17, fontWeight: 500, color: colors.text }}>Toute l'équipe pourra y contribuer. Il reste ouvert jusqu'à ce qu'on le termine.</p>
			<BottomBar>
				<div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
					{error && <ErrorNote>Le tour n'a pas pu être créé. Vérifiez la connexion, puis réessayez.</ErrorNote>}
					<PrimaryButton icon={saving || empty ? null : <CheckIcon />} disabled={empty || saving} onClick={start}>{saving ? 'Création…' : 'Démarrer le tour'}</PrimaryButton>
					{empty && <p style={{ fontSize: 15, fontWeight: 600, color: colors.textSecondary, textAlign: 'center' }}>Donnez un nom au tour</p>}
				</div>
			</BottomBar>
		</div>
	)
}
